























import { Vue, Component, Prop } from 'vue-property-decorator'
import { FadeTransition } from 'vue2-transitions'
import Card from '@/components/Card.vue'
import Button from '@/components/Button.vue'
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Card,
    FadeTransition,
    Loader,
    Button,
  }
})
export default class ListMerchantVasses extends Vue {
  loading = true
  stores!: Array<MerchantStore>

  async fetch () {
    try {
      const { _embedded = { vasses: [] } } = await this.$tinabaAPI.$vas.listPublicVasses(this.$route.params.merchantId)
      this.stores = _embedded.vasses
    } catch (error) {} finally {
      this.loading = false
    }
  }

  created () {
    this.fetch()
  }
}
